/**
 * base API url service
 *
 * all urls for the APIs
 * @deprecated use ApiResourceService instead
 *
 */

import {Injectable} from '@angular/core';

// Import RxJs required methods

declare const userCompanyId: string;

@Injectable()
export class ApiUrlService {

    //vars
    public response: any = {data: {}, display: {}};

    constructor() {
        this.initRoot();
        this.init();
        this.initApiUrls();
    }

    public prefix = sessionStorage.getItem("$instance_url");
    public apiUrl = this.prefix + "api/";
    public apiServerUrl = this.prefix + "apiServer/";
    public apiOldOsman = this.prefix + "wui_stock/index.php/";


    public apiAddons: any;

    public group: any = {
        host: '',
        target: ''
    };
    public galileo: any = {
        target: ''
    };
    public m_apiUrl: any = {};

    // URL
    public initApiUrls(): void {
        this.m_apiUrl = {
            'testTripsPropertiesQuotes': {
                'url': {'before': "https://jsonblob.com/991b46ed-b3df-11e7-81b3-8349c96dda99"},
                'method': 'get',
                'storePath': 'jsonBlob'
            },
            'testJsonBlob': {
                'url': {'before': "https://jsonblob.com/api/jsonBlob/"},
                'method': 'get',
                'storePath': 'jsonBlob'
            }
            , 'jsonblob': {
                'url': {'before': "https://jsonblob.com/api/jsonBlob/"},
                'method': 'get'
            }
            , 'putJsonblob': {
                'url': {'before': "https://jsonblob.com/api/jsonBlob/61d97bf4-78eb-11e7-9e0d-ab0af43f1bbc"},
                'method': 'put'
            }
            , 'patchJsonblob': {
                'url': {'before': "https://jsonblob.com/api/jsonBlob/61d97bf4-78eb-11e7-9e0d-ab0af43f1bbc"},
                'method': 'patch'
            }
            , 'file': {
                'url': {'before': "../../../wui/dummyDatas/", "after": ".json"},
                'method': 'get'
            }
            , 'getTnr': { //getBooking
                'url': {
                    'before': this.apiUrl + 'group/hosts/' + this.group.host + '/bookings/',
                    'after': '?merge=OSMAN'
                },
                'method': 'get',
                'storePath': 'tnr',
                'additionalHeader': {
                    'target': this.group.target //§TODO+EJ+2317+09+07 : make it from Yii/Synchronyme/Parameters
                }
            }
            , 'getPnr': { //getJourneyByReference
                'url': {
                    'before': this.apiUrl + 'group/journeys?reference=', //+id
                    'after': '&host=GALILEO'
                },
                'method': 'get',
                'storePath': 'pnr',
                'fallBack': 'getPnrAir'
            }
            , 'getPnrAir': { //getJourneyByReference
                'url': {
                    'before': this.apiUrl + 'group/hosts/GALILEO/bookings/',
                },
                'method': 'get',
                'storePath': 'pnr',
                'additionalHeader': {
                    'target': this.galileo.target //§TODO+EJ+2317+09+07 : make it from Yii/Synchronyme/Parameters
                }
            }
            , 'getTigre': { //getJourneyById
                'url': {
                    'before': this.apiUrl + 'group/journeys/' //+id
                },
                'method': 'get',
                'storePath': 'pnr'
            }
            , 'createPnr': {
                'url': this.apiUrl + 'group/journeys',
                'method': 'put',
                'storePath': 'pnr',
                'additionalHeader': {
                    'target': this.galileo.target
                }
            }
            , 'updatePnr': {
                'url': {
                    'before': this.apiUrl + 'group/journeys/'
                },
                'method': 'patch',
                'storePath': 'pnr'
            }
            , 'wtbDestinationSearch': {
                'url': this.apiServerUrl + 'watabi/destinations/search',
                'method': 'post',
                'storePath': 'wtbDestinationSearch'
            }
            , 'wtbItem': {
                'url': this.apiServerUrl + 'watabi/item',
                'method': 'post',
                'storePath': 'wtbItemPost'
            }
            , 'wtbSubmission_Add': {
                'url': {
                    "before": this.apiServerUrl + 'watabi/elements/',
                    "after": '/submissions/add'
                },
                'method': 'post',
                'additionalHeader': {
                    "mode": "Manual"
                }
            }
            , 'wtbSubmission_Accept': {
                'url': {
                    "before": this.apiServerUrl + 'watabi/elements/',
                    "after": '/submissions/accept'
                },
                'method': 'post'
            }
            , 'wtbSubmission_Reject': {
                'url': {
                    "before": this.apiServerUrl + 'watabi/elements/',
                    "after": '/submissions/reject'
                },
                'method': 'post'
            }
            , 'wtbSubmission_Push': {
                'url': {
                    "before": this.apiServerUrl + 'watabi/elements/',
                    "after": '/submissions/push'
                },
                'method': 'post'
            }
            , 'wtbSubmission_Search': {
                'url': {
                    'before': this.apiServerUrl + 'watabi/elements/submissions/search',
                    'after': '?count=5&first=0'
                },
                'method': 'post'
            }
            , 'wtbItemGet': {
                'url': {
                    'before': this.apiServerUrl + 'watabi/item/'
                },
                'method': 'get',
                'storePath': 'wtbItemGet'
            }
            , 'wtbBlockSearch': {
                'url': {
                    'before': this.apiServerUrl + 'watabi/blocks/search'
                },
                'method': 'get',
                'storePath': 'wtbBlockSearch'
            }
            , 'wtbCacheUpdate': {
                'url': {
                    'before': this.apiServerUrl + 'watabi/cache/update'
                },
                'method': 'get',
                'storePath': 'wtbCacheUpdate'
            }
            , 'citiesGetter': {
                'url': {
                    'before': this.apiServerUrl + 'watabi/locations'
                },
                'method': 'get',
                'storePath': 'citiesGetter'
            }
            , 'cityGetter': {
                'url': {
                    'before': this.apiServerUrl + 'watabi/locations/',
                },
                'method': 'get',
                'storePath': 'cityGetter',
            }
            , 'wtbBlocksGetter': {
                'url': {
                    'before': this.apiUrl + 'watabi/blocks/',
                    'after': '/summary?style=RIAK'
                },
                'method': 'get',
                'storePath': 'wtbBlocksGetter'
            }
            , 'airportsGetter': {
                'url': {
                    'before': this.apiServerUrl + 'airports'
                },
                'method': 'get',
                'noToken': 'true',
                'storePath': 'airportsGetter'
            }
            , 'getPaxtype': {
                'url': {
                    'before': this.apiUrl + 'osman/contracts/',
                    'after': '/travellertypes'
                },
                'method': 'get',
                'storePath': 'getPaxtype'
            }
            , 'putPaxtype': {
                'url': {
                    'before': this.apiUrl + 'osman/contracts/',
                    'after': '/travellertypes'
                },
                'method': 'put',
                'storePath': 'putPaxtype'
            }
            , 'generateContent': {
                'url': this.apiUrl + 'air/contents/generate',
                'method': 'post',
                'additionalHeader': {
                    'target': sessionStorage.getItem('target')
                }
            }
            , 'generateContentVehicle': {
                'url': this.apiUrl + 'vehicleRental/contents/generate',
                'method': 'post',
                'additionalHeader': {
                    'target': sessionStorage.getItem('target')
                }
            }
            , 'getHosts': {
                'url': this.apiUrl + 'sam/sso/hosts',
                'method': 'get',
            }
            , 'getContractRoute': {
                'url': {
                    'before': this.apiUrl + 'osman/contracts/',
                    'after': '/routes'
                },
                'method': 'get',
                'storePath': 'routes',
                'useCompanyId': true,
            }
            , 'routeConvert': {
                'url': {
                    'before': this.apiUrl + 'osman/contracts/',
                    'after': '/routes/convert'
                },
                'method': 'post',
                'storePath': 'routes'
            }
            , 'getRoute': {
                'url': {
                    "0": this.apiUrl + 'osman/routes/'
                },
                'method': 'get',
                'storePath': 'routes'
            }
            , 'getJourneysFromRoute': {
                'url': {
                    'before': this.apiUrl + 'osman/routes/',
                    'after': '/journeys'
                },
                'method': 'get',
                'storePath': 'routes'
            }
            , 'putRoute': {
                'url': {
                    'before': this.apiUrl + 'osman/routes/'
                },
                'method': 'put',
                'storePath': 'routes'
            }
            , 'createNewRoute': {
                'url': {
                    'before': this.apiUrl + 'osman/contracts/',
                    'after': '/routes/create'
                },
                'method': 'post',
                'storePath': 'routes'
            }
            , 'duplicateRoute': {
                'url': {
                    'before': this.apiUrl + 'osman/routes/',
                    'after': '/duplicate'
                },
                'method': 'post',
                'storePath': 'routes'
            }
            , 'deleteRoute': {
                'url': this.apiOldOsman + 'routes/deleteRoute/',
                'method': 'post',
                'storePath': 'routes'
            }
            , 'schedulePost': {
                'url': this.apiOldOsman + 'schedule/searchDistinct/',
                'method': 'post',
                'storePath': 'schedule'
            }
            , 'scheduleGet': {
                'url': this.apiOldOsman + 'schedule/searchDistinct/get',
                'method': 'post',
                'storePath': 'scheduleGet'
            }
            , 'scheduleUpdate': {
                'url': this.apiOldOsman + 'schedule/update',
                'method': 'post',
                'storePath': 'scheduleUp'
            }
            , 'duplicateContract': {
                'url': {
                    'before': this.apiUrl + 'osman/contracts/',
                    'after': '/duplicate'
                },
                'method': 'post',
                'storePath': 'contract'
            }
            , 'duplicateContractInTemplate': {
                'url': {
                    'before': this.apiUrl + 'osman/contracts/',
                    'after': '/duplicate?template=true'
                },
                'method': 'post',
                'storePath': 'contract'
            }, 'associateExternalReferencesToBooking': {
                url: {
                    "0": this.apiUrl + "osman/bookings/",
                    "1": "/hosts/bookings"
                },
                method: "patch",
            }
        };
    }


    public init(): void {
        this.initRoot();
        this.initMe();
    }

    /**
     * only for root
     */
    public initRoot(): void {
        //
    }

    /**
     * to be overwrited
     */
    public initMe(): void {
        //
    }


}
